module.exports = __webpack_public_path__ + "static/img/tittle.74a02443.png";